import React, { useState, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import styles from '../Form.module.scss';

import { FormLabel } from 'components/FormComponents';
import FormInputText from 'components/FormComponents/FormInputText/FormInputText';
import SectionTitle from '../SectionTitle';
import AddButton from 'components/Buttons/AddButton';

export function Links() {
  const { setValue, getValues } = useFormContext();
  const [links, setLinks] = useState([]);

  useEffect(() => {
    const interval = setInterval(() => {
      const externalLinks = getValues('externalLinks');
      if (externalLinks?.length) {
        setLinks(externalLinks.map(({ id, url, text }) => ({ id, url, text })));
        clearInterval(interval);
      }
    }, 50);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const cleanLinks = links.map(({ id, url, text }) => (id ? { id, url, text } : { url, text }));
    setValue('externalLinks', cleanLinks);
  }, [links, setValue]);

  const handleAddLink = () => {
    setLinks((prev) => [...prev, { url: '', text: '' }]);
  };

  const handleLinkChange = (index, field, value) => {
    setLinks((prev) => prev.map((link, i) => (i === index ? { ...link, [field]: value } : link)));
  };

  const handleRemoveLink = (index) => {
    setLinks((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <div className={styles.general}>
      <SectionTitle>Links</SectionTitle>
      <div className={styles.form}>
        {links.map((link, index) => (
          <React.Fragment key={index}>
            <div className={styles.form__block}>
              <div className={styles.form__block_row}>
                <FormLabel>Link</FormLabel>
                <FormInputText
                  name={`externalLinks.${index}.url`}
                  value={link.url}
                  onChange={(name, value) => handleLinkChange(index, 'url', value)}
                  options={{ max: 255 }}
                />
              </div>
            </div>

            <div className={styles.form__block}>
              <div className={styles.form__block_row}>
                <FormLabel>Text to Display</FormLabel>
                <FormInputText
                  name={`externalLinks.${index}.text`}
                  value={link.text}
                  onChange={(name, value) => handleLinkChange(index, 'text', value)}
                  options={{ max: 255 }}
                />
                <button
                  type="button"
                  className={styles.deleteButton}
                  onClick={() => handleRemoveLink(index)}>
                  ✖
                </button>
              </div>
            </div>
          </React.Fragment>
        ))}

        <div className={styles.form__block}>
          <AddButton onClick={handleAddLink}>Add links</AddButton>
        </div>
      </div>
    </div>
  );
}
